import { createModel } from "@rematch/core";
import { KoreModel } from "./";
import { JSX } from "react";

export interface PinnedApp {
  id: string | number;
  type: number;
  onClick?: () => void;
  label: string;
  icon: JSX.Element;
}

const model = {
  name: "pinnedApps",
  state: [] as PinnedApp[],
  reducers: { setData: (currentState: PinnedApp[], data: PinnedApp[]) => data }
};

export const pinnedAppsModel = createModel<KoreModel>()(model);
